import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnnotatedOrder, DealerRemoteMaintenanceOrder, DealerRemoteMaintenanceValidateOrderItem, OrderItemStatus } from 'src/app/generated/CrossPoint.License.Server';

export interface OrderDetailsDialogData {
  dealerRemoteMaintenanceOrder: DealerRemoteMaintenanceOrder;
  annotatedOrder: AnnotatedOrder;
}

@Component({
  selector: 'xpac-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {  

  public newLicenses: DealerRemoteMaintenanceValidateOrderItem[] = [];
  public cancelledLicenses: DealerRemoteMaintenanceValidateOrderItem[] = [];
  public displayedColumnsNewLicenses = ['store'];
  public displayedColumnsCancelledLicenses = ['store'];

  constructor( public dialogRef: MatDialogRef<OrderDetailsComponent>, @Inject(MAT_DIALOG_DATA) public ordedLicenseDetails: OrderDetailsDialogData) {}

  ngOnInit(): void {
    this.setLicenses();
  }

  public onNoClick(): void {   
    this.dialogRef.close(true);    
  }

  private setLicenses(): void{
    let newLicenses: DealerRemoteMaintenanceValidateOrderItem[] = [];
    let cancelledLicenses: DealerRemoteMaintenanceValidateOrderItem[] = [];

    this.ordedLicenseDetails.dealerRemoteMaintenanceOrder.items.forEach((order: DealerRemoteMaintenanceValidateOrderItem) => {
      if(order.status === OrderItemStatus.CancelledSubscription){
        cancelledLicenses.push(order);
      }
      else{
        newLicenses.push(order);
      }
    });

    this.newLicenses = newLicenses;
    this.cancelledLicenses = cancelledLicenses;    
  }

  public getStoreInfoString(order: DealerRemoteMaintenanceValidateOrderItem): string{
  
    const store = this.ordedLicenseDetails.annotatedOrder.items.find(s => s.deviceId === order.serial);

    let subTitle = order.serial;
    if (store.storeAddress.street) {
      subTitle += ` - ${store.storeAddress.street} ${store.storeAddress.streetNumber}`;
    }
  
    return subTitle;
  }

  public getStoreName(order: DealerRemoteMaintenanceValidateOrderItem): string{  
    return this.ordedLicenseDetails.annotatedOrder.items.find(s => s.deviceId === order.serial).storeName || "";
  }

  public getCompanyName(): string{    
    return this.ordedLicenseDetails.annotatedOrder.createdByUser.companyName;
  }

}
